import React from 'react';
import SchoolIcon from '@mui/icons-material/School';
import './Training/Training.css'; // Import css modules stylesheet as styles
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import QuizIcon from '@mui/icons-material/Quiz';
import CalculateIcon from '@mui/icons-material/Calculate';
import TokenService from '../services/TokenService';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import CheckIcon from '@mui/icons-material/Check';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import TrainingItemsIndicator from './Training/TrainingItemsIndicator.jsx';

function Training() {
    React.useEffect(() => {
        loadTrainingViewed(); // only called once
    }, []);

    const [panelsViewed, setPanelsViewed] = React.useState([]);
    const [userLevel, setUserLevel] = React.useState(null);
    const [showTrainingChecklist, setShowTrainingChecklist] = React.useState(false);
    const [expanded, setExpanded] = React.useState(false);


    const handleChange = (panel) => (event, isExpanded) => {

        if (!panelsViewed.includes(panel)) {
            panelsViewed.push(panel);
            updatePanelViewed(panel);
            setPanelsViewed(panelsViewed);
        }

        setExpanded(isExpanded ? panel : false);
    };

    const [panelOpened, setPanelOpened] = React.useState(false);

    const handlePanelChange = (panel) => (event, isOpened) => {
        setPanelOpened(panel.Card.Name);
        if (panel.Items.length == 0) {
            // best practices has no items
            if (!panelsViewed.includes(panel.Card.Name)) {
                panelsViewed.push(panel.Card.Name);
                updatePanelViewed(panel.Card.Name);
                setPanelsViewed(panelsViewed);
            }
        }
    };

    function loadTrainingViewed() {
      

        TokenService.post('', 'Returner_GetTrainingViewed')
            .then((response) => {
            
                if (response.Result === "SUCCESS") {
                    let data = JSON.parse(response.JsonData);
                    let level = JSON.parse(data.ReturnerLevel);
                    setUserLevel(level);

                    data = JSON.parse(data.TrainingViewed);
                    let alreadyViewed = [];
                    for (let i = 0; i < data.length; i++) {
                        alreadyViewed.push(data[i].PanelName);
                    }
                    setPanelsViewed(alreadyViewed);
                
                }
            })
            .catch((response) => {

            });
    }

    function updatePanelViewed(panelName) {
        //panelsViewed.push
        let postData = {
            panelName: panelName
        }
        
        TokenService.post(postData, 'Returner_SetTrainingViewed')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                let jsonData = JSON.parse(response.JsonData);
                let level = JSON.parse(jsonData.ReturnerLevel);
                if (userLevel.TrainingChecklist.RemainingItemCount > 0 &&
                    level.TrainingChecklist.RemainingItemCount == 0) {
                    //alert('training completed');
                    level.AllTrainingCompleted = true;
                }
                else if (userLevel.TrainingChecklist.IsTrainingCompleted == false &&
                         level.TrainingChecklist.IsTrainingCompleted == true) {
                        // training module completed
                    //alert('training module completed');
                    level.TrainingModuleCompleted = true;
                }
                setUserLevel(level);
            })
            .catch((response) => {
              
            });
    }

    const trainingContent = [
        {
            Card: {
                Name: 'Profile',
                Content: <>
                    <AccountCircleIcon sx={{ color: 'var(--sipzee-gray)', fontSize: '40pt' }} style={{ alignSelf: 'center', marginLeft: '10px' }} />
                    <Typography style={{ marginLeft: '20px', alignSelf: 'center', fontWeight: 'bold' }}>
                        Account Setup
                    </Typography>
                </>
            }
            , ItemsTitle: 'Account Setup'
            , ItemsSubtitle: 'Profile pic, Service areas ...'
            , ItemsHeader: <div>
                To setup your account, please complete the following items in the My Account page
            </div>
            , Items: [
                {
                    Name: 'profile-panel1',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Add a profile pic
                        </Typography>
                    </>,
                    Content:
                        <div>
                            <div>in My Account:</div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <img src='images/training/addprofilepic.jpg' style={{ maxWidth: '300px', width: '100%' }} />
                            </div>
                        </div>
                },
                {
                    Name: 'profile-panel2',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Verify your phone number
                        </Typography>
                    </>,
                    Content: <div>
                        <div>in My Account:</div>
                        <div style={{display:'flex'} }>
                        <div style={{display:'flex', flexDirection:'column'} }>
                            <img src='images/training/verifyphone1.jpg' style={{ marginTop: '10px', maxWidth: '300px', width:'100%', alignSelf:'center' }} />
                            <KeyboardDoubleArrowDownIcon style={{ marginTop: '10px', alignSelf: 'center' }} />
                                <img src='images/training/verifyphone2.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                            <KeyboardDoubleArrowDownIcon style={{ marginTop: '10px', alignSelf: 'center' }} />
                                <img src='images/training/verifyphone2.b.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                            <KeyboardDoubleArrowDownIcon style={{ marginTop: '10px', alignSelf: 'center' }} />
                                <img src='images/training/verifyphone3.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                            </div>
                        </div>
                    </div>
                },
                {
                    Name: 'profile-panel3',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Add Service Areas - Simple
                        </Typography>
                    </>,
                    Content: <>
                        <div>in My Account:</div>
                        <div style={{ display: 'flex' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <img src='images/training/serviceareassimple1.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                                <KeyboardDoubleArrowDownIcon style={{ marginTop: '10px', alignSelf: 'center' }} />
                                <img src='images/training/serviceareassimple2.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                                <KeyboardDoubleArrowDownIcon style={{ marginTop: '10px', alignSelf: 'center' }} />
                                <img src='images/training/serviceareassimple3.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                            </div>
                        </div>
                    </>
                },
                {
                    Name: 'profile-panel4',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Add Service Areas - Advanced (optional)
                        </Typography>
                    </>,
                    Content: <div>
                        <div>in My Account:</div>
                        <div style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <img src='images/training/serviceareasadvanced1.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                                <KeyboardDoubleArrowDownIcon style={{ marginTop: '10px', alignSelf: 'center' }} />
                                <img src='images/training/serviceareasadvanced2.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                               
                            </div>
                        </div>
                    </div>
                }
            ]
        },

        {
            Card: {
                Name: 'Pickup',
                Content: <>
                    <DirectionsCarIcon sx={{ color: 'var(--sipzee-gray)', fontSize: '40pt' }} style={{ alignSelf: 'center', marginLeft: '10px' }} />
                    <Typography style={{ marginLeft: '20px', alignSelf: 'center', fontWeight: 'bold' }}>
                        Pickup Process
                    </Typography>
                </>
            }
            , ItemsTitle: 'Pickup Process'
            , ItemsSubtitle: 'Viewing, Scheduling, Claiming...' 
            , ItemsHeader: <div>
                
            </div>
            , Items: [
                {
                    Name: 'pickup-panel1',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Search available pickup requests
                        </Typography>
                    </>,
                    Content: <div>
                        <div style={{ display: 'flex' }}><div style={{ alignSelf: 'center' }}>in My Pickups </div><ArrowRightIcon /> <div style={{ alignSelf: 'center' }}>Available Orders:</div></div>
                        <div style={{ display: 'flex', marginTop:'10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div>
                                    Click a row to expand it or click on the map pin:
                                </div>
                                <img src='images/training/pickupsclaim1.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />

                                <div style={{ marginTop: '20px' }}>
                                    Expanding a row lets you view more details:
                                </div>
                                <img src='images/training/pickupsclaim2.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />

                            </div>
                        </div>
                    </div>
                },
                {
                    Name: 'pickup-panel2',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            View pickup requests details
                        </Typography>
                    </>,
                    Content: <div>
                        <div style={{ display: 'flex' }}><div style={{ alignSelf: 'center' }}>in My Pickups </div><ArrowRightIcon /> <div style={{ alignSelf: 'center' }}>Available Orders:</div></div>
                        <div style={{ display: 'flex', marginTop: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div>
                                    <ol>
                                        <li>Flag an order for us if you notice an issue</li>
                                        <li>The amount you will purchase this order for</li>
                                        <li>The estimated profit you will make after recycling</li>
                                        <li>Extra details and photos</li>
                                    </ol>
                                </div>
                                <img src='images/training/pickupsdetails1.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />

                               

                            </div>
                        </div>
                    </div>
                },
                {
                    Name: 'pickup-panel3',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Claim and scheduled pickup
                        </Typography>
                    </>,
                    Content: <>
                        <div>
                            <div>When viewing the Order Details, select Claim:</div>

                       

                            <div style={{ display: 'flex' }}>
                              
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Button target="_blank" href="https://sipzeephotos.blob.core.windows.net/training/ClaimPickup.webm" variant="contained" style={{ backgroundColor: "var(--sipzee-green)", maxWidth: '250px', alignSelf:'center', marginTop:'10px' }} >
                                        <div style={{ display: 'flex' }}><OndemandVideoIcon /><div style={{ alignSelf: 'center', marginLeft: '10px' }}>See it in action</div> </div>
                                    </Button>

                                    <img src='images/training/PickupScheduling1.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                                    <KeyboardDoubleArrowDownIcon style={{ marginTop: '10px', alignSelf: 'center' }} />
                                    <ol>
                                        <li>Select a Date for your pickup</li>
                                        <li>Select a Time window</li>
                                        <li>Click Schedule</li>
                                    </ol>
                                    <div style={{fontStyle:'italic'} }>Note: for business locations, these times will be restricted to their open business hours.</div>
                                    <img src='images/training/PickupScheduling3.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />

                                    <div style={{ marginTop: '20px' }}>Hooray! The order will now show up in your My Open Orders section!</div>
                          
                      
                                    
                                </div>
                            </div>
                        </div>
                    </>
                },
                {
                    Name: 'pickup-panel3.b',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Reschedule or Unschedule a pickup
                        </Typography>
                    </>,
                    Content: <>
                        <div>
                             <div style={{ display: 'flex' }}><div style={{ alignSelf: 'center' }}>in My Pickups </div><ArrowRightIcon /> <div style={{ alignSelf: 'center' }}>My Open Orders:</div></div>

                            <div>
                                Select the order you wish to Reschedule/Unschedule:
                            </div>

                            <div style={{ display: 'flex' }}>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Button target="_blank" href="https://sipzeephotos.blob.core.windows.net/training/RescheduleUnschedulePickup.webm" variant="contained" style={{ backgroundColor: "var(--sipzee-green)", maxWidth: '250px', alignSelf: 'center', marginTop: '10px' }} >
                                        <div style={{ display: 'flex' }}><OndemandVideoIcon /><div style={{ alignSelf: 'center', marginLeft: '10px' }}>See it in action</div> </div>
                                    </Button>

                                    <img src='images/training/rescheduleunschedulepickup.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />

                                    <div style={{ marginTop: '20px' }}>The order will now be moved back to the Available Orders section!</div>



                                </div>
                            </div>
                        </div>
                    </>
                },

                {
                    Name: 'pickup-panel4',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Complete pickup
                        </Typography>
                    </>,
                    Content: <>
                        <div>
                            <div style={{ display: 'flex' }}><div style={{ alignSelf: 'center' }}>in My Pickups </div><ArrowRightIcon /> <div style={{ alignSelf: 'center' }}>My Open Orders:</div></div>

                            <div style={{fontWeight:'bold', marginTop:'10px', marginBottom:'10px'} }>
                                Please arrive at the address before purchasing.
                            </div>

                            <div>
                                Select the order you wish to complete.
                            </div>

                            <div style={{ display: 'flex' }}>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Button target="_blank" href="https://sipzeephotos.blob.core.windows.net/training/PurchasePickup.webm" variant="contained" style={{ backgroundColor: "var(--sipzee-green)", maxWidth: '250px', alignSelf: 'center', marginTop: '10px' }} >
                                        <div style={{ display: 'flex' }}><OndemandVideoIcon /><div style={{ alignSelf: 'center', marginLeft: '10px' }}>See it in action</div> </div>
                                    </Button>

                                    <img src='images/training/purchasepickup1.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                                    <KeyboardDoubleArrowDownIcon style={{ marginTop: '10px', alignSelf: 'center' }} />
                                    <div>Complete the payment:</div>
                                    <img src='images/training/purchasepickup2.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                                    <div style={{ marginTop: '20px' }}>The order will now be moved to your Completed Orders section</div>



                                </div>
                            </div>
                        </div>
                    </>
                },
                {
                    Name: 'pickup-panel5',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            How your actions impact customers
                        </Typography>
                    </>,
                    Content: <>
                        <table id="Returner_Customer_Impact_Table" cellPadding="0" cellSpacing="0">
                            <thead>
                                <tr>
                                    <th>Your Action</th>
                                    <th>Customer Impact</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Claim a Pickup</td>
                                    <td>The customer is automatically sent an email indicating their pickup has been schedule.  They are provided with the following information;
                                        <ul>
                                            <li>Date & time you selected for the pickup</li>
                                            <li>Your first name and profile picture so they know who to expect</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Update Your Claimed Pickup</td>
                                    <td>The customer is automatically sent an email indicating their pickup has been re-scheduled.  They are provided with the following information;
                                        <ul>
                                            <li>The updated date & time you selected for the pickup</li>
                                            <li>Your first name and profile picture so they know who to expect</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Unschedule Your Claimed Pickup</td>
                                    <td>The customer is automatically sent an email indicating their pickup has been unscheduled and are told they will have to wait for a new returner to claim
                                        their order.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Purchase Your Claimed Pickup</td>
                                    <td>IMPORTANT - ONLY DO THIS WHEN YOU ARRIVE AT THE PICKUP LOCATION AND ARE ABOUT TO LOAD THEIR CANS & BOTTLES INTO YOUR VEHICLE.
                                        <br />
                                        <br />
                                        The customer is automatically sent an email indicating their pickup
                                        has been completed along with a digital check to pay them for the cans & bottles you just purchased.
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                    </>
                }
            ]
        },
        {
            Card: {
                Name: 'FAQ',
                Content: <>
                    <QuizIcon sx={{ color: 'var(--sipzee-gray)', fontSize: '40pt' }} style={{ alignSelf: 'center', marginLeft: '10px' }} />
                    <Typography style={{ marginLeft: '20px', alignSelf: 'center', fontWeight: 'bold' }}>
                        Frequently Asked Questions
                    </Typography>
                </>
            }
            , ItemsTitle: 'Frequently Asked Questions'
            , ItemsSubtitle: '' 
            , ItemsHeader: null
            , Items: [
                {
                    Name: 'faq-panel1',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            How do I make money?
                        </Typography>
                    </>,
                    Content: <>
                        <div>
                            Each customer pickup request has an estimated quantity of bottles & cans.
                        </div>
                        <div style={{marginTop:'10px'} }>
                            You purchase these for 6&#162; per estimated item and recycle them at a local store for 10&#162;, keeping 4&#162; in profit. 
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            You are an independent entrepreneur, purchasing scrap metal & plastic at a 40% discount, then recycling it for full value and keeping the profits.
                        </div>
                        
                        <div style={{backgroundColor:'var(--sipzee-gray)'} }>
                            <img src='images/training/bottleinfographic.svg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                        </div>
                    </>
                },
                {
                    Name: 'faq-panel2',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Why am I purchasing cans & bottles based on an estimated quantity vs. the actual quantity?
                        </Typography>
                    </>,
                    Content: <>
                        <div>
                            It is not efficient to count and track which bottles & cans go with what customer orders.  Therefore, Sipzee pickup orders are based on system of estimates and this means
                            you may profit more on some orders and less on others, but you should always make a solid profit. While we cannot guarantee the estimated value used
                            to calculate the purchase price is exact, the Sipzee <span style={{ textDecoration: 'underline', fontWeight: 'bold' }} >app is designed to underestimate the quantity in your favor</span>.
                            In general, you should find that you actually received more cans & bottles than you paid for, which we refer to as 'Bonus Bottles'.  See below example.
                            <div style={{ marginTop: '10px' }} >
                                <table className="Training_ExampleTable" cellSpacing={0} cellPadding={0}>
                                    <thead>
                                        <tr>
                                            <th>Example Order</th>
                                            <th>Quantity</th>
                                            <th>Value</th>
                                            <th>Price</th>
                                            <th>Estimated Profit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ fontWeight:'bold'}}>Sipzee Amount</td>
                                            <td>1,000</td>
                                            <td>$100</td>
                                            <td rowSpan={2}>$60</td>
                                            <td>$40</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: 'bold' }}>Actual Amount</td>
                                            <td>1,200</td>
                                            <td>$120</td>
                                            <td>$60</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={5}>After you recycle the cans &amp; bottles at the store, you may find that you purchased 1,200 cans &amp; bottles for the price of 1,000 and therefore made $60, rather than $40, in profit.
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </>
                }
                ,
                {
                    Name: 'faq-panel3',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            What are 'Bonus Bottles'?
                        </Typography>
                    </>,
                    Content: <>
                        Bonus bottles are extra cans & bottles you receive for free.This occurs when the actual quantity you picked up is more than the estimated quantity you paid for.You make 10&cent; (100%) profit on each one of these instead of the standard 4&cent;.
                    </>
                },
                {
                    Name: 'faq-panel4',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                           How do I pay for the cans & bottles
                        </Typography>
                    </>,
                    Content: <>
                        <div>
                            When you click the purchase button in the Sipzee app, you will be given the option to purchase the cans & bottles using a credit/debit card or a PayPal account.
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            Please ensure you have sufficient funds available to make the purchase before claiming and scheduling a pick up request. 
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            After recycling, you will receive cash from the store for the full value of the cans & bottles which is yours to keep. See 'How do I make Money?' for more information.
                        </div>
                        <div style={{display:'flex', justifyContent:'center'} }>
                        <Button target="_blank" href="https://sipzeephotos.blob.core.windows.net/training/PurchasePickup.webm" variant="contained" style={{ backgroundColor: "var(--sipzee-green)", maxWidth: '250px', alignSelf: 'center', marginTop: '10px' }} >
                            <div style={{ display: 'flex' }}><OndemandVideoIcon /><div style={{ alignSelf: 'center', marginLeft: '10px' }}>See it in action</div> </div>
                            </Button>
                        </div>
                    </>
                },
                {
                    Name: 'faq-panel5',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            When do I purchase the cans & bottles?
                        </Typography>
                    </>,
                    Content: <>
                        You will purchase the cans & bottles <span style={{ fontWeight: 'bold' }}> after you have arrived at the pickup location</span>, before you load them into your vehicle. Once you are ready to purchase, simply open up our application on your phone, select the order and click the 'Purchase' button. See Pickup Process - Complete a Pickup above for more detail.
                    </>
                },
                {
                    Name: 'faq-panel6',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            What if I cannot make it to pickup an order at the original date and time window I selected?
                        </Typography>
                    </>,
                    Content: <>
                        <div>You can open the order and select the 'Update' button which will let you reschedule the date and time and inform the customer of the change.</div>
                        <div style={{ marginTop: '10px' }}>Providing excellent customer service is important so please keep this to a minimum. If this becomes a regular occurrence, your Sipzee account may be suspended.</div>
                        <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
                            <Button target="_blank" href="https://sipzeephotos.blob.core.windows.net/training/RescheduleUnschedulePickup.webm" variant="contained" style={{ backgroundColor: "var(--sipzee-green)", alignSelf: 'center', marginTop: '10px' }} >
                                <div style={{ display: 'flex' }}><OndemandVideoIcon /><div style={{ alignSelf: 'center', marginLeft: '10px' }}>See Reschedule/Unschedule in action</div> </div>
                            </Button>
                        </div>
                    </>
                },
                {
                    Name: 'faq-panel7',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            What If I claimed a pickup request but decide I no longer want to purchase the cans & bottles?
                        </Typography>
                    </>,
                    Content: <>
                        <div>You can open the order and select the 'Unschedule' button which will remove it from your queue and inform the customer of the change.</div>
                        <div style={{ marginTop: '10px' }}>Providing excellent customer service is important so please keep this to a minimum. </div>
                        <div style={{ marginTop: '10px' }}>Ensure you review all of the information provided before you claim a pickup request. If this becomes a regular occurrence, your Sipzee account may be suspended.</div>
                        <div style={{ marginTop: '10px' }}>If there is an unexpected issue with the pickup request, you may click the  button on the order and a Sipzee team member will follow up to resolve the issue.</div>
                        <div style={{marginTop:'10px', display:'flex', justifyContent:'center'} }>
                            <Button target="_blank" href="https://sipzeephotos.blob.core.windows.net/training/RescheduleUnschedulePickup.webm" variant="contained" style={{ backgroundColor: "var(--sipzee-green)",  alignSelf: 'center', marginTop: '10px' }} >
                                <div style={{ display: 'flex' }}><OndemandVideoIcon /><div style={{ alignSelf: 'center', marginLeft: '10px' }}>See Reschedule/Unschedule in action</div> </div>
                            </Button>
                        </div>
                    </>
                },
                {
                    Name: 'faq-panel8',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            What if I arrive at a pickup where nobody is home and I can't locate the cans & bottles?
                        </Typography>
                    </>,
                    Content: <>
                        <div>
                            You can open up the order on your phone to communicate directly with the customer using either the Phone or Messaging buttons:
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src='images/training/customercommunication1.jpg' style={{ marginTop: '10px', maxWidth: '300px', width: '100%', alignSelf: 'center' }} />
                        </div>

                        <div style={{marginTop:'10px'} }>
                            The Phone button will initiate a call to you, then to the customer. This will hide your number from them and call them using a Sipzee number.
                        </div>

                        <div style={{ marginTop: '10px' }}>
                            If you still can't find the cans & bottles, you can click the Flag Order button on the order and a Sipzee team member will follow up to resolve the issue. However, we would recommend moving on to your next pickup at that time.
                        </div>
                        <div style={{display:'flex', justifyContent:'center'} }>
                            <img src='images/training/flagorder1.jpg' />   
                        </div>
                    </>
                },
                {
                    Name: 'faq-panel9',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Do I need to keep track of what cans & bottles go with each order I pickup?
                        </Typography>
                    </>,
                    Content: <>
                        No, because of our estimate/purchase at the door policy, you can recycle all of the cans & bottles you have at any time, and keep all of the cash you receive.
                    </>
                },
                {
                    Name: 'faq-panel10',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            What if some of the cans & bottles I purchased are not accepted at the store I'm recycling them at?
                        </Typography>
                    </>,
                    Content: <>
                        You can save them to return at a store where they are accepted or if it's just a few cans & bottles you may decide it is more convenient to dispose of them. We recommend saving them and once you have a large enough quantity, look up a store online that does accept them and then recycle. If a store sells the beverage, they are required to accept them for recycling.
                    </>
                },
                {
                    Name: 'faq-panel11',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            Do I need to pay taxes while recycling using Sipzee?
                        </Typography>
                    </>,
                    Content: <>
                        You should pay taxes in accordance with any local, state, and federal laws that apply to you. Please consult with an accountant or tax attorney if you require more detail. Please note - you will not receive any tax documentation from Sipzee and there are no tax withholdings that result from the use of our application. The Sipzee business model does not allow us track income as you will be paid in cash from local stores after recycling cans & bottles. We do recommend keeping track of mileage driven and any expenses incurred while recycling as you will likely be able to write these off on an income tax statement.
                    </>
                },
                {
                    Name: 'faq-panel12',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            What should I do if a customer asks me a question about Sipzee?
                        </Typography>
                    </>,
                    Content: <>
                        From time to time, you may run into a customer while you are at their house picking up cans & bottles and they may have questions about Sipzee and the process. If you know the answer to their question, then answer it. If you do not know the answer or are uncertain, explain that you unfortunately do not know and politely direct them to use the "Contact Us" feature on www.sipzee.com to submit their question. A Sipzee team member will then follow-up with the customer.
                    </>
                },
                {
                    Name: 'faq-panel13',
                    Header: <>
                        <Typography style={{ marginLeft: '10px' }}>
                            What if the store I recycle my cans & bottles at is enforcing a $25/day maximum?
                        </Typography>
                    </>,
                    Content: <>
                        Stores are only required to accept 250 ($25) per day in cans & bottles per person and it is likely that all stores will have signs up indicating such. This has become more prevalent due to the COVID-19 pandemic as stores would like as few people recycling for as little time as possible to reduce the likelihood of virus transmission.
                        However, keep in mind that you are recycling cans & bottles on behalf of many local households who would otherwise be doing so themselves and are therefore <span style={{ fontWeight: 'bold' }}>helping with the reduction of crowding and virus transmission.</span> It is unlikely that if you follow the rules and wait your turn in line, that the $25/day maximum will be enforced. However, there are actions you can take to help;

                        <ul>
                            <li>
                                Recycle your bottles and cans at large retail stores that have automated reverse vending machines such as Meijer, Walmart, Kroger, Aldi, Family Fare, Save A Lot, etc. Do not take large quantities of cans & bottles to small party stores or gas stations.
                            </li>
                            <li>
                                While recycling - be polite, respectful, clean up after yourself, and follow all of the store's rules. Wear a mask while in the store!
                            </li>
                            <li>
                                Recycle during non-peak hours. This is typically early in the morning or late at night.
                            </li>
                            <li>
                                <span style={{ fontWeight: 'bold' }}>DO NOT attempt to walk into the store with multiple shopping carts full of cans & bottles. </span>
                                Recycle one cart full at a time and then go back to your vehicle to refill the cart. You should be able to fit 300-400 cans & bottles ($30-$40) in a standard size shopping cart
                            </li>
                            <li>
                                If you are questioned at a store about the quantity of cans & bottles you are recycling, politely explain that you are recycling these on behalf of many of other people so they would not have to come to the store and that you are recycling one cart load at a time and waiting your turn in line.
                            </li>
                            <li>
                                If you do run into issues at a particular store, try another.
                            </li>
                        </ul>

                        <div style={{ marginTop: '10px' }}>See 'Best Practices' for more information.</div>

                        <div style={{ marginTop: '10px' }}>Lastly, please feel free to send us a note if you are having issues. As Sipzee continues to grow, we will be connecting with stores to help them improve efficiency and safety within their recycling centers.</div>
                    </>
                }
            ]
        },
        {
            Card: {
                Name: 'BestPractices',
                Content: <>
                    <DirectionsCarIcon sx={{ color: 'var(--sipzee-gray)', fontSize: '40pt' }} style={{ alignSelf: 'center', marginLeft: '10px' }} />
                    <Typography style={{ marginLeft: '20px', alignSelf: 'center', fontWeight: 'bold' }}>
                        Best Practices
                    </Typography>
                </>
            }
            , ItemsTitle: 'Best Practices'
            , ItemsSubtitle: ''
            , ItemsHeader: <div>
                
                <div >
                    <div>

                    </div>
                    <CalculateIcon style={{ color: 'var(--sipzee-green)', fontSize:'40', marginRight:'3px' }} />
                        Before claiming/purchasing cans & bottles, perform a quick verification to ensure the quantity of bottles & cans <span style={{ fontWeight: 'bold' }}>roughly</span> matches what you are paying for. We do not recommend spending time counting individual cans & bottles but rather quickly looking at the overall number of bags/boxes to develop your own rough estimate. Sipzee has created a Quick Estimate Reference Guide to help with this.
                        <div style={{ marginTop: '10px' }}>
                            <span style={{ fontWeight: 'bold' }}>The purpose of this activity is to ensure the order does not contain an extreme over-estimate that might result in you picking up significantly less cans & bottles than what you are paying for. </span> As indicated in the FAQ section, if the customer used the Sipzee estimate tool correctly, the order should generally result in you receiving more cans & bottles than you paid for, not less.However, there may be occasional scenarios where the order quantity is over-estimated but unless this is by an extreme amount, it should not deter you from proceeding.Keep in mind that even if you purchased an estimated 1000 cans ($60 cost at 6&cent; per can) and the actual ended up being 800 cans ($80 cash after recycling at 10&cent; per can). You would still make $20 profit on the transaction.
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            Note - The purchase price for an order is not negotiable and all purchases are final so if you do encounter an order that is extremely over-estimated, please click on the flag order button before claiming or purchasing the order so a Sipzee team member can follow up with the customer and remove it from the Sipzee market if necessary.
                        </div>
                   
                    <li style={{marginTop:'10px'} }>
                        When possible, always complete as many pickups as you can before recycling the cans & bottles for their deposit cash. This is much more efficient than immediately recycling cans & bottles after each pickup.
                    </li>
                    <li style={{ marginTop: '10px' }}>
                        Use our map feature to try and claim as many pickup requests as you can that are near one another to reduce drive times.
                    </li>
                    <li style={{ marginTop: '10px' }}>
                        Save cans and bottles that can only be recycled at certain stores until you have a large enough quantity and then recycle them all.
                    </li>
                    <li style={{ marginTop: '10px' }}>
                        Recycle your bottles and cans at large retail stores that have automated reverse vending machines such as Meijer, Walmart, Kroger, Aldi, Family Fare, Save A Lot, etc. Do not take large quantities of cans & bottles to small party stores or gas stations.
                    </li>
                    <li style={{ marginTop: '10px' }}>
                        Recycle during non-peak hours. This is typically early in the morning or late at night.
                    </li>
                    <li style={{ marginTop: '10px' }}>
                        While recycling - be polite, respectful, clean up after yourself, and follow all of the store's rules. Wear a mask while in the store!
                    </li>
                    <li style={{ marginTop: '10px' }}>
                        <span style={{ fontWeight: 'bold' }}>DO NOT attempt to walk into the store with multiple shopping carts full of cans & bottles. </span>
                        Recycle one cart full at a time and then go back to your vehicle to refill the cart. You should be able to fit 300-400 cans & bottles ($30-$40) in a standard size shopping cart.
                    </li>
                    <li style={{ marginTop: '10px' }}>
                        Line your trunk and seats with a protective barrier - if you drive a smaller vehicle, you are likely going to want to utilize your trunk, rear seats, and passenger seat for transporting cans & bottles.
                    </li>
                    <li style={{ marginTop: '10px' }}>
                        We do recommend keeping track of mileage driven and any expenses incurred while recycling as you will likely be able to write these off on an income tax statement. See 'Frequently Asked Questions' section for more details.
                    </li>
                  
                </div>
            </div>
            , Items: [

            ]
        }
    ];

    function allItemsViewed(card) {
        if (card != undefined) {
            if (card.Items !== undefined) {
                for (let i = 0; i < card.Items.length; i++) {
                    if (!panelsViewed.includes(card.Items[i].Name)) {
                        return false;
                    }
                }
                if (card.Items.length == 0) {
                    // no items, so use the card.name
                    if (!panelsViewed.includes(card.Card.Name)) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    return (
        <div>
            {userLevel == null || userLevel == undefined ? null :
                <TrainingItemsIndicator ShowDialog={showTrainingChecklist} ShowIndicator={false} TrainingChecklist={userLevel.TrainingChecklist} />
            }
            <div style={{ width: '100%', height: '200px', backgroundColor: 'var(--sipzee-yellow-3)', display:'flex', alignItems:'center' }}>

                <div style={{ alignSelf: 'center' }}>

                    <div style={{ display:'flex', flexDirection:'column', padding:'25px'}}>
                        <div className='Page-Header' style={{ display: 'flex',justifyContent: 'flex-start' }}>
                            <SchoolIcon style={{ marginRight: '10px' }} sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} />
                            <div style={{}}>Training Guide</div>
                        </div>
                        <div style={{fontSize:'22pt', display: 'flex', alignSelf: 'center', justifyContent: 'flex-start' }}>
                            Making your first pickup.
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ padding:'25px'  }}>


                <div className='sectionHeader' style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    Before you start
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left' }}>
                    We want to get you off to a great start! We'll walk you through setting up your account and describe how the pickup process works.
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left', marginTop:'10px' }}>
                    <CheckIcon sx={{color:'var(--sipzee-green)', fontSize:30, marginRight:'5px'}} /> To complete the training you need to click and expand each section.
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left', marginTop: '10px' }}>
                    <SentimentNeutralIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30, marginRight: '5px' }} /> Is it a little boring? yes. But it should take about 10 mins.
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left', marginTop: '10px' }}>
                    <img src='images/laughingiconGreen.svg' style={{ height:'30px', fontSize: 30, marginRight: '5px' }} /> There are no stupid questions. So if you still have some, feel free to ask us. But if it's a question that is answered in the Training, we'll know you didn't read it.
                </div>
                
            </div>

            <div style={{ padding: '25px' }}>
                {
                    
                    trainingContent.map((item, index) => {
                        console.log('Card' + index)
                        return <div key={'Card-' + index}>
                            <Card onClick={handlePanelChange(item)} style={{marginBottom:'10px'} }>
                                <CardContent style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                    {allItemsViewed(item) ?
                                        <AssignmentTurnedInIcon sx={{ color: 'var(--sipzee-green)' }} style={{ alignSelf: 'center' }} />
                                        :
                                        <AssignmentIcon sx={{ color: 'var(--sipzee-yellow)' }} style={{ alignSelf: 'center' }} />
                                    }

                                    {item.Card.Content}
                                    <ArrowForwardIcon sx={{ fontSize: '30pt' }} style={{ alignSelf: 'center', marginLeft: 'auto' }} />
                                </CardContent>
                            </Card>

                            <SlidingPane key={'Slider-' + index}
                                width="100%"
                                className='trainingOverlaypanel '
                                overlayClassName="some-custom-overlay-class"
                                isOpen={panelOpened === item.Card.Name}
                                title={item.ItemsTitle}
                                subtitle={item.ItemsSubtitle}
                                onRequestClose={() => {
                                    // triggered on "<" on left top click or on outside click
                                    setPanelOpened(false);
                                    if (userLevel.TrainingModuleCompleted) {
                                        //alert('Training Module Completed');
                                        setShowTrainingChecklist(true);
                                    }
                                    else if (userLevel.AllTrainingCompleted) {
                                        alert('All Training Completed');
                                    }
                                }}
                            >
                                {item.ItemsHeader}
                                {item.Items.map((detailItem, detailIndex) => {
                                    return <Accordion expanded={expanded === detailItem.Name} key={'Accordion_' + detailIndex} onChange={handleChange(detailItem.Name)}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                        >
                                            {panelsViewed.includes(detailItem.Name) || panelsViewed.includes(item.Card.Name) ?
                                                <AssignmentTurnedInIcon sx={{ color: 'var(--sipzee-green)' }} />
                                                :
                                                <AssignmentIcon sx={{ color: 'var(--sipzee-yellow)' }} />
                                            }

                                            {detailItem.Header}

                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {detailItem.Content}
                                        </AccordionDetails>
                                    </Accordion>
                                })
                                }
                            </SlidingPane>

                        </div>
                           
                       
                    })

                   
                }
               
               
                
            </div>
        </div>
    );
}

export default Training;